export const ECONOMY_SHIPPING_FILTER_CHIP_BACKGROUND_COLOR =
  'var(--primitive-solid-neutral-100)'

export const ECONOMY_SHIPPING_FILTER_CHIP_TEXT_COLOR =
  'var(--primitive-solid-neutral-0)'

export const ECONOMY_SHIPPING_FILTER_CHIP_ICON_COLOR =
  'var(--primitive-solid-neutral-100)'

export const ECONOMY_SHIPPING_FILTER_CHIP_SELECTED_ICON_COLOR =
  'var(--primitive-solid-neutral-0)'
